import enviro from 'enviro';
const PACKAGE_NAME = 'marketplace-storefront-ui';
export function debug() {
  return String(enviro.debug(PACKAGE_NAME)) === 'true';
}
export function debugLog(...args) {
  if (debug()) {
    console.log(...args);
  }
}
export function deployed() {
  return enviro.deployed(PACKAGE_NAME);
}
export function isQa() {
  return enviro.isQa(PACKAGE_NAME);
}
export function isProd() {
  return enviro.isProd(PACKAGE_NAME);
}